<template>
  <div class="layout/margin:top:page:2">
    <div
      class="
        $color/background:alpha:54%
        $color/background:gray:eee
        color/background
      "
      >
      <div
        class="
          layout/align:start
          layout/flex:column
          layout/grid:gap:page
          layout/padding:bottom:page
          layout/padding:top:page
          layout/wrapper
        "
        >
        <form
          class="
            layout/flex:column
            layout/grid:gap:page
            layout/width:100%
          "
          autocapitalize="none"
          autocomplete="off"
          autocorrect="off"
          action="/collection/works/"
          accept-charset="UTF-8"
          method="get"
          @submit.prevent="onSubmit"
          >
          <SearchInput
            ref="input"
            :value="q"
            aria-label-input="Press return to search."
            aria-label-reset="Clear search terms."
            gtm="collection / search"
            input-placeholder="Search artists and works"
            @searchInput="(val) => $emit('search-input', val)"
            @searchReset="$emit('search-reset')"
          />
          <div
            class="
              layout/grid:gap:page:1.5
              layout/grid:1
              layout/align:center
              layout/width:100%
            "
            >
            <div
              class="
                @1024/layout/flex
                layout/grid:2
                layout/grid:gap:page:0.5
              "
              >
              <Checkbox
                :checked="withImages"
                checkbox-name="has_images"
                label="Has image"
                gtm="collection / has images"
                @clickedCheckbox="(val) => $emit('update-checked', {name: 'with_images', value: val})"
              />
              <Checkbox
                :checked="onView"
                checkbox-name="on_view"
                label="On view in the Museum"
                gtm="collection / on view"
                @clickedCheckbox="(val) => $emit('update-checked', {name: 'on_view', value: val})"
              />
              <Checkbox
                :checked="recentAcquisitions"
                checkbox-name="recent_acquisitions"
                label="Recent acquisition"
                gtm="collection / recent acquisitions"
                @clickedCheckbox="(val) => $emit('update-checked', {name: 'recent_acquisitions', value: val})"
              />
              <Checkbox
                :checked="includeUncataloguedWorks"
                checkbox-name="include_uncatalogued_works"
                label="Include uncatalogued works"
                gtm="collection / include uncatalogued works"
                @clickedCheckbox="(val) => $emit('update-checked', {name: 'include_uncataloged_works', value: val})"
              />
            </div>
            <CollapsibleBlockAtomized
              v-if="isCollapsible"
              aria-label="Advanced collection form filters"
              block-name="Advanced collection form filters"
              toggle-text-closed="Hide filters"
              toggle-text-open="Show more filters"
              class="
                $typography/size:medium
                layout/width:100%
              "
              >
              <div
                class="
                  @768/layout/flex
                  layout/grid:1
                  layout/grid:gap:page:0.5
                "
                style="--768--select--width--max: 30rem;"
                >
                <div
                  class="
                    @768/layout/width:max
                    layout/width:100%
                    link/focus
                  "
                  style="--768--layout--width--max: var(--768--select--width--max);"
                  >
                  <Select
                    id="classificationsFilter"
                    :options="classificationFilterOptions"
                    :value="classifications"
                    aria-label="Filter by classifications"
                    name="classificationsFilter"
                    @input="(val) => $emit('update-classifications', val)"
                  />
                </div>
                <div
                  class="
                    @768/layout/flex
                    layout/align:center
                    layout/flex:row
                    layout/grid:gap:page:0.5
                    layout/width:100%
                  "
                  >
                  <div
                    class="
                      @768/layout/width:max
                      layout/width:100%
                      link/focus
                    "
                    style="--768--layout--width--max: var(--768--select--width--max);"
                    >
                    <Select
                      id="fromYearFilter"
                      :value="dateBegin"
                      :options="fromYearOptions"
                      aria-label="Filter by begin date"
                      name="fromYearFilter"
                      @input="(val) => $emit('update-from-year-date', val)"
                    />
                  </div>
                  <span class="$typography/size:medium typography typography/align:center">through</span>
                  <div
                    class="
                      @768/layout/width:max
                      layout/width:100%
                      link/focus
                    "
                    style="--768--layout--width--max: var(--768--select--width--max);"
                    >
                    <Select
                      id="toYearFilter"
                      :options="toYearOptions"
                      :value="dateEnd"
                      aria-label="Filter by end date"
                      name="toYearFilter"
                      @input="(val) => $emit('update-to-year-date', val)"
                    />
                  </div>
                </div>
              </div>
            </CollapsibleBlockAtomized>
            <div
              v-if="!isCollapsible"
              aria-label="Advanced collection form filters"
              class="
                $typography/size:medium
                layout/width:100%
              "
              >
              <div
                class="
                  @768/layout/flex
                  layout/grid:1
                  layout/grid:gap:page:0.5
                "
                style="--768--select--width--max: 30rem;"
                >
                <div
                  class="
                    @768/layout/width:max
                    layout/width:100%
                    link/focus
                  "
                  style="--768--layout--width--max: var(--768--select--width--max);"
                  >
                  <Select
                    id="classificationsFilter"
                    :options="classificationFilterOptions"
                    :value="classifications"
                    aria-label="Filter by classifications"
                    name="classificationsFilter"
                    @input="(val) => $emit('update-classifications', val)"
                  />
                </div>
                <div
                  class="
                    @768/layout/flex
                    layout/align:center
                    layout/flex:row
                    layout/grid:gap:page:0.5
                    layout/width:100%
                  "
                  >
                  <div
                    class="
                      @768/layout/width:max
                      layout/width:100%
                      link/focus
                    "
                    style="--768--layout--width--max: var(--768--select--width--max);"
                    >
                    <Select
                      id="fromYearFilter"
                      :value="dateBegin"
                      :options="fromYearOptions"
                      aria-label="Filter by begin date"
                      name="fromYearFilter"
                      @input="(val) => $emit('update-from-year-date', val)"
                    />
                  </div>
                  <span class="$typography/size:medium typography typography/align:center">through</span>
                  <div
                    class="
                      @768/layout/width:max
                      layout/width:100%
                      link/focus
                    "
                    style="--768--layout--width--max: var(--768--select--width--max);"
                    >
                    <Select
                      id="toYearFilter"
                      :options="toYearOptions"
                      :value="dateEnd"
                      aria-label="Filter by end date"
                      name="toYearFilter"
                      @input="(val) => $emit('update-to-year-date', val)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import { options } from "./options";
  import Checkbox from 'Components/form/checkbox.vue';
  import SearchInput from 'Components/form/search-input';
  import Select from 'Components/form/select';
  import CollapsibleBlockAtomized from 'Components/shared/blocks/collapsible-block--atomized.vue';

  export default {
    components: {
      Checkbox,
      CollapsibleBlockAtomized,
      SearchInput,
      Select
    },

    props: {
      classifications: { type: String, required: true },
      dateBegin: { type: String, required: true },
      dateEnd: { type: String, required: true },
      includeUncataloguedWorks: { type: Boolean, required: true },
      onView: { type: Boolean, required: true },
      q: { type: String, required: true },
      recentAcquisitions: { type: Boolean, required: true },
      withImages: { type: Boolean, required: true },
      classificationFilterOptions: { type: Array, required: true },
      isCollapsible: { type: Boolean, required: true },
    },

    data() {
      return {
        dateRangeOptions: options.dateRangeOptions(),
        fromYearOptions: [],
        toYearOptions: [],
      };
    },

    watch: {
      /**
       * Watched value for `dateBegin` to reactively constrict the `toYearOptions` based on the "from-year" option.
       *
       * @param {string} newVal A string representing a selected year option
       */
      dateBegin(newVal) {
        this.toYearOptions = this.dateRangesForSelect({ minYear: newVal });
      }
    },

    mounted() {
      this.fromYearOptions = this.dateRangesForSelect({ maxYear: this.dateEnd });
      this.toYearOptions = this.dateRangesForSelect({ minYear: this.dateBegin });
    },

    methods: {
      dateRangesForSelect({ minYear = options.optionPre1850, maxYear = options.optionMaxYear }) {
        const lowerBoundIdx = this.dateRangeOptions.indexOf(minYear);
        const upperBoundIdx = this.dateRangeOptions.indexOf(maxYear);

        return this.dateRangeOptions.slice(lowerBoundIdx, upperBoundIdx+1);
      },

      onSubmit() {
        this.$refs.input.blurInput();
        this.$emit('form-submit');
      }
    }
  };
</script>
